import { Link } from 'react-router-dom';
import { Button } from '@mantine/core';
import { useTranslation } from '../context/TranslationContext';
import './NotFound.css';

export default function NotFound() {
  const { t } = useTranslation();

  return (
    <main className="not-found-page">
      <h1>404</h1>
      <h2>{t('pageNotFound')}</h2>
      <p>{t('pageNotFoundDesc')}</p>
      <Button component={Link} to="/" variant="filled" size="lg" aria-label={t('goHome')}>{t('goHome')}</Button>
    </main>
  );
}